// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_llwwi){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_1iEwb .dualColumn_5Q_Bi{display:flex;align-content:space-between}.nsAddressForm_1iEwb .dualColumn_5Q_Bi .firstCol_13i03{margin-right:20px}.optional_cx-wt{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_llwwi",
	"nsAddressForm": "nsAddressForm_1iEwb",
	"dualColumn": "dualColumn_5Q_Bi",
	"firstCol": "firstCol_13i03",
	"optional": "optional_cx-wt"
};
module.exports = exports;
